import React from 'react';
import './FieldsTable.css';

function FieldsTable({ fields, selectedField, onFieldClick, onDragStart }) {
  return (
    <div className="fields-table-container">
      <table className="fields-table">
        <thead>
          <tr>
            <th>Field Name</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {fields.map(field => (
            <tr
              key={field.id}
              className={`field-row ${selectedField?.id === field.id ? 'selected' : ''}`}
              draggable
              onDragStart={(e) => onDragStart(e, field)}
              title={`Drag to map this value. Value: ${field.value}`}
            >
              <td className="field-name">{field.key}</td>
              <td className="field-value">{field.value}</td>
              <td className="field-action">
                <button
                  className="highlight-btn"
                  onClick={() => onFieldClick(field)}
                  title="Click to highlight in PDF"
                >
                  Locate
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {fields.length === 0 && (
        <div className="empty-state">
          <p>No fields extracted yet. Upload a JSON file or run the pipeline.</p>
        </div>
      )}

      <div className="table-info">
        <span>💡 Tip: Click "Locate" to highlight a field in the PDF, or drag a value to custom fields</span>
      </div>
    </div>
  );
}

export default FieldsTable;
